import {createSelector} from "reselect";

const Jobs = (state) => state.jobs;
const jobsData = createSelector(Jobs, (data) => data?.jobsData || {});

export const getJobsList = createSelector(jobsData, (data) => data?.results || []);

export const getTotalCount = createSelector(jobsData, (data) => data?.count);

export const getJobsPaginationUrls = createSelector(jobsData, (data) => ({
  prevUrl: data?.previous,
  nextUrl: data?.next,
}));

export const getSelectedJob = createSelector(Jobs, (data) => data.selectedJob || {});
